import React from 'react';

const ResetPasswordLinkPage = () => {
  return <h1>Redirecting...</h1>;
};

export default ResetPasswordLinkPage;
